import { UseFormReturn, useWatch } from 'react-hook-form';
import { useTranslations } from 'use-intl';
import type { SetRangeFormFields } from '../types';

type Form = UseFormReturn<SetRangeFormFields>;

export interface Props {
  poolType: 'pair' | 'eth' | 'nft';
  control: Form['control'];
  setValue: Form['setValue'];
  canEditRange: boolean;
  setDisabled: (v: boolean) => void;
  onFullRangeChange: (v: boolean) => void;
}

export const InfiniteRange = ({
  poolType,
  control,
  setValue,
  canEditRange,
  setDisabled,
  onFullRangeChange,
}: Props) => {
  // formatting
  const t = useTranslations('CreateLiquidityPositionForms.SetRange');
  // type of pool
  const isPair = poolType === 'pair';

  // watch for when the actual form tick values are updated - source of truth
  const { price = '0', fullRange = false } = useWatch({
    control,
  });

  const hasPrice = !!price && !!Number(price) && !Number.isNaN(Number(price));

  if (!isPair || !canEditRange) {
    return null;
  }

  return (
    <button
      type="button"
      disabled={!hasPrice}
      onClick={() => {
        const value = !fullRange;
        setValue('fullRange', value);
        setDisabled(true);
        onFullRangeChange(value);
      }}
      className={`w-full text-center border p-2 rounded-md mt-2 transition-colors focus:ring-2 focus:ring-gray-100 focus:outline-0 ${
        fullRange
          ? ' bg-pink-50 text-pink-500 border-pink-500'
          : ' hover:border-pink-500 border-gray-300 '
      }`}
    >
      {t('infinite')}
    </button>
  );
};

export default InfiniteRange;
